import ApplicationAdapter from 'eflex/adapters/application';

export default class KeyenceAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
